/* Generated from the capture pass over staging.waslx.app — see
   docs/screenshots/manifest.json. Keyed by the route slug each capture came
   from; ModuleShowcase maps its module ids onto these keys.

   Mobile numbers are masked at capture time (first two digits kept), so
   these are safe to publish. Regenerate rather than hand-edit. */
const SCREENS = {
  "login": [
    {
      "src": "/docs/screens/login/page.webp",
      "kind": "page",
      "note": "Sign-in: org code, email, password",
      "label": "Full screen"
    }
  ],
  "dashboard": [
    {
      "src": "/docs/screens/dashboard/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/dashboard/tab-this-month.webp",
      "kind": "tab-this-month",
      "note": "Tab / filter: This Month",
      "label": "This month"
    },
    {
      "src": "/docs/screens/dashboard/tab-this-week.webp",
      "kind": "tab-this-week",
      "note": "Tab / filter: This Week",
      "label": "This week"
    },
    {
      "src": "/docs/screens/dashboard/tab-today.webp",
      "kind": "tab-today",
      "note": "Tab / filter: Today",
      "label": "Today"
    }
  ],
  "approvals-leaves": [
    {
      "src": "/docs/screens/approvals-leaves/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/approvals-leaves/tab-all.webp",
      "kind": "tab-all",
      "note": "Tab / filter: All",
      "label": "All"
    },
    {
      "src": "/docs/screens/approvals-leaves/tab-approved.webp",
      "kind": "tab-approved",
      "note": "Tab / filter: Approved",
      "label": "Approved"
    },
    {
      "src": "/docs/screens/approvals-leaves/tab-pending.webp",
      "kind": "tab-pending",
      "note": "Tab / filter: Pending",
      "label": "Pending"
    },
    {
      "src": "/docs/screens/approvals-leaves/tab-rejected.webp",
      "kind": "tab-rejected",
      "note": "Tab / filter: Rejected",
      "label": "Rejected"
    }
  ],
  "assessments": [
    {
      "src": "/docs/screens/assessments/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/assessments/action-new-assessment.webp",
      "kind": "action-new-assessment",
      "note": "\"New assessment\" panel — opened, not submitted",
      "label": "New assessment"
    }
  ],
  "assessments-detail": [
    {
      "src": "/docs/screens/assessments-detail/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/assessments-detail/tab-questions.webp",
      "kind": "tab-questions",
      "note": "Tab / filter: Questions",
      "label": "Questions"
    },
    {
      "src": "/docs/screens/assessments-detail/tab-scoring-outcomes.webp",
      "kind": "tab-scoring-outcomes",
      "note": "Tab / filter: Scoring & outcomes",
      "label": "Scoring outcomes"
    },
    {
      "src": "/docs/screens/assessments-detail/tab-settings.webp",
      "kind": "tab-settings",
      "note": "Tab / filter: Settings",
      "label": "Settings"
    }
  ],
  "assessments-detailresults": [
    {
      "src": "/docs/screens/assessments-detailresults/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    }
  ],
  "attendance-records": [
    {
      "src": "/docs/screens/attendance-records/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/attendance-records/tab-this-month.webp",
      "kind": "tab-this-month",
      "note": "Tab / filter: This month",
      "label": "This month"
    },
    {
      "src": "/docs/screens/attendance-records/tab-this-week.webp",
      "kind": "tab-this-week",
      "note": "Tab / filter: This week",
      "label": "This week"
    },
    {
      "src": "/docs/screens/attendance-records/tab-today.webp",
      "kind": "tab-today",
      "note": "Tab / filter: Today",
      "label": "Today"
    }
  ],
  "campaigns": [
    {
      "src": "/docs/screens/campaigns/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/campaigns/action-new-campaign.webp",
      "kind": "action-new-campaign",
      "note": "\"New campaign\" panel — opened, not submitted",
      "label": "New campaign"
    }
  ],
  "configuration-attendance": [
    {
      "src": "/docs/screens/configuration-attendance/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/configuration-attendance/tab-holidays.webp",
      "kind": "tab-holidays",
      "note": "Tab / filter: Holidays",
      "label": "Holidays"
    },
    {
      "src": "/docs/screens/configuration-attendance/tab-leave-types.webp",
      "kind": "tab-leave-types",
      "note": "Tab / filter: Leave types",
      "label": "Leave types"
    },
    {
      "src": "/docs/screens/configuration-attendance/tab-shift-timing.webp",
      "kind": "tab-shift-timing",
      "note": "Tab / filter: Shift timing",
      "label": "Shift timing"
    },
    {
      "src": "/docs/screens/configuration-attendance/tab-working-days.webp",
      "kind": "tab-working-days",
      "note": "Tab / filter: Working days",
      "label": "Working days"
    }
  ],
  "configuration-custom-fields": [
    {
      "src": "/docs/screens/configuration-custom-fields/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/configuration-custom-fields/action-add-field.webp",
      "kind": "action-add-field",
      "note": "\"Add field\" panel — opened, not submitted",
      "label": "Add field"
    },
    {
      "src": "/docs/screens/configuration-custom-fields/row-edit.webp",
      "kind": "row-edit",
      "note": "Edit form — opened, not saved",
      "label": "Edit form"
    },
    {
      "src": "/docs/screens/configuration-custom-fields/row-menu.webp",
      "kind": "row-menu",
      "note": "Row actions: View / Edit / Delete",
      "label": "Row actions"
    }
  ],
  "configuration-dids": [
    {
      "src": "/docs/screens/configuration-dids/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/configuration-dids/action-add-did.webp",
      "kind": "action-add-did",
      "note": "\"Add DID\" panel — opened, not submitted",
      "label": "Add did"
    }
  ],
  "configuration-ivr-flows": [
    {
      "src": "/docs/screens/configuration-ivr-flows/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    }
  ],
  "configuration-sip-trunks": [
    {
      "src": "/docs/screens/configuration-sip-trunks/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/configuration-sip-trunks/action-add-trunk.webp",
      "kind": "action-add-trunk",
      "note": "\"Add trunk\" panel — opened, not submitted",
      "label": "Add trunk"
    }
  ],
  "customers": [
    {
      "src": "/docs/screens/customers/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/customers/action-add-customer.webp",
      "kind": "action-add-customer",
      "note": "\"Add customer\" panel — opened, not submitted",
      "label": "Add customer"
    },
    {
      "src": "/docs/screens/customers/action-assign-agents.webp",
      "kind": "action-assign-agents",
      "note": "\"Assign Agents\" panel — opened, not submitted",
      "label": "Assign agents"
    },
    {
      "src": "/docs/screens/customers/action-bulk-upload.webp",
      "kind": "action-bulk-upload",
      "note": "\"Bulk Upload\" panel — opened, not submitted",
      "label": "Bulk upload"
    },
    {
      "src": "/docs/screens/customers/advanced-filters.webp",
      "kind": "advanced-filters",
      "note": "Advanced filter panel expanded",
      "label": "Advanced filters"
    },
    {
      "src": "/docs/screens/customers/row-delete-confirm.webp",
      "kind": "row-delete-confirm",
      "note": "Delete confirmation — CANCELLED, nothing deleted",
      "label": "Delete confirmation"
    },
    {
      "src": "/docs/screens/customers/row-edit.webp",
      "kind": "row-edit",
      "note": "Edit form — opened, not saved",
      "label": "Edit form"
    },
    {
      "src": "/docs/screens/customers/row-menu.webp",
      "kind": "row-menu",
      "note": "Row actions: View / Edit / Delete",
      "label": "Row actions"
    },
    {
      "src": "/docs/screens/customers/row-view.webp",
      "kind": "row-view",
      "note": "Record detail view",
      "label": "Detail view"
    }
  ],
  "customers-groups": [
    {
      "src": "/docs/screens/customers-groups/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/customers-groups/action-add-group.webp",
      "kind": "action-add-group",
      "note": "\"Add group\" panel — opened, not submitted",
      "label": "Add group"
    }
  ],
  "customers-sources": [
    {
      "src": "/docs/screens/customers-sources/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    }
  ],
  "customers-templates": [
    {
      "src": "/docs/screens/customers-templates/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/customers-templates/action-add-template.webp",
      "kind": "action-add-template",
      "note": "\"Add template\" panel — opened, not submitted",
      "label": "Add template"
    },
    {
      "src": "/docs/screens/customers-templates/row-delete-confirm.webp",
      "kind": "row-delete-confirm",
      "note": "Delete confirmation — CANCELLED, nothing deleted",
      "label": "Delete confirmation"
    },
    {
      "src": "/docs/screens/customers-templates/row-edit.webp",
      "kind": "row-edit",
      "note": "Edit form — opened, not saved",
      "label": "Edit form"
    },
    {
      "src": "/docs/screens/customers-templates/row-menu.webp",
      "kind": "row-menu",
      "note": "Row actions: View / Edit / Delete",
      "label": "Row actions"
    }
  ],
  "messages": [
    {
      "src": "/docs/screens/messages/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/messages/action-new-dm.webp",
      "kind": "action-new-dm",
      "note": "\"New DM\" panel — opened, not submitted",
      "label": "New dm"
    }
  ],
  "notifications": [
    {
      "src": "/docs/screens/notifications/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    }
  ],
  "profile": [
    {
      "src": "/docs/screens/profile/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/profile/action-add.webp",
      "kind": "action-add",
      "note": "\"Add\" panel — opened, not submitted",
      "label": "Add"
    }
  ],
  "reports": [
    {
      "src": "/docs/screens/reports/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/reports/tab-agents.webp",
      "kind": "tab-agents",
      "note": "Tab / filter: Agents",
      "label": "Agents"
    },
    {
      "src": "/docs/screens/reports/tab-communications.webp",
      "kind": "tab-communications",
      "note": "Tab / filter: Communications",
      "label": "Communications"
    },
    {
      "src": "/docs/screens/reports/tab-customers.webp",
      "kind": "tab-customers",
      "note": "Tab / filter: Customers",
      "label": "Customers"
    },
    {
      "src": "/docs/screens/reports/tab-overview.webp",
      "kind": "tab-overview",
      "note": "Tab / filter: Overview",
      "label": "Overview"
    },
    {
      "src": "/docs/screens/reports/tab-productivity-attendance.webp",
      "kind": "tab-productivity-attendance",
      "note": "Tab / filter: Productivity & Attendance",
      "label": "Productivity attendance"
    },
    {
      "src": "/docs/screens/reports/tab-sales-payments.webp",
      "kind": "tab-sales-payments",
      "note": "Tab / filter: Sales & Payments",
      "label": "Sales payments"
    },
    {
      "src": "/docs/screens/reports/tab-this-month.webp",
      "kind": "tab-this-month",
      "note": "Tab / filter: This Month",
      "label": "This month"
    },
    {
      "src": "/docs/screens/reports/tab-this-week.webp",
      "kind": "tab-this-week",
      "note": "Tab / filter: This Week",
      "label": "This week"
    },
    {
      "src": "/docs/screens/reports/tab-today.webp",
      "kind": "tab-today",
      "note": "Tab / filter: Today",
      "label": "Today"
    }
  ],
  "sip-call": [
    {
      "src": "/docs/screens/sip-call/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    }
  ],
  "skills": [
    {
      "src": "/docs/screens/skills/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/skills/action-add-skill.webp",
      "kind": "action-add-skill",
      "note": "\"Add skill\" panel — opened, not submitted",
      "label": "Add skill"
    },
    {
      "src": "/docs/screens/skills/action-bulk-import.webp",
      "kind": "action-bulk-import",
      "note": "\"Bulk Import\" panel — opened, not submitted",
      "label": "Bulk import"
    },
    {
      "src": "/docs/screens/skills/action-load-sample.webp",
      "kind": "action-load-sample",
      "note": "Load sample skills panel",
      "label": "Load sample"
    },
    {
      "src": "/docs/screens/skills/row-delete-confirm.webp",
      "kind": "row-delete-confirm",
      "note": "Delete confirmation — CANCELLED, nothing deleted",
      "label": "Delete confirmation"
    },
    {
      "src": "/docs/screens/skills/row-edit.webp",
      "kind": "row-edit",
      "note": "Edit form — opened, not saved",
      "label": "Edit form"
    },
    {
      "src": "/docs/screens/skills/row-menu.webp",
      "kind": "row-menu",
      "note": "Row actions: View / Edit / Delete",
      "label": "Row actions"
    }
  ],
  "support": [
    {
      "src": "/docs/screens/support/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    }
  ],
  "support-issue-types": [
    {
      "src": "/docs/screens/support-issue-types/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/support-issue-types/action-add-issue-type.webp",
      "kind": "action-add-issue-type",
      "note": "\"Add issue type\" panel — opened, not submitted",
      "label": "Add issue type"
    },
    {
      "src": "/docs/screens/support-issue-types/row-delete-confirm.webp",
      "kind": "row-delete-confirm",
      "note": "Delete confirmation — CANCELLED, nothing deleted",
      "label": "Delete confirmation"
    },
    {
      "src": "/docs/screens/support-issue-types/row-edit.webp",
      "kind": "row-edit",
      "note": "Edit form — opened, not saved",
      "label": "Edit form"
    },
    {
      "src": "/docs/screens/support-issue-types/row-menu.webp",
      "kind": "row-menu",
      "note": "Row actions: View / Edit / Delete",
      "label": "Row actions"
    }
  ],
  "task-statuses": [
    {
      "src": "/docs/screens/task-statuses/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/task-statuses/action-new-status.webp",
      "kind": "action-new-status",
      "note": "\"New status\" panel — opened, not submitted",
      "label": "New status"
    }
  ],
  "tasks": [
    {
      "src": "/docs/screens/tasks/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    }
  ],
  "teams": [
    {
      "src": "/docs/screens/teams/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/teams/action-add-team.webp",
      "kind": "action-add-team",
      "note": "\"Add team\" panel — opened, not submitted",
      "label": "Add team"
    }
  ],
  "users": [
    {
      "src": "/docs/screens/users/page.webp",
      "kind": "page",
      "note": "Full page",
      "label": "Full screen"
    },
    {
      "src": "/docs/screens/users/action-add-user.webp",
      "kind": "action-add-user",
      "note": "\"Add user\" panel — opened, not submitted",
      "label": "Add user"
    },
    {
      "src": "/docs/screens/users/action-bulk-upload.webp",
      "kind": "action-bulk-upload",
      "note": "\"Bulk Upload\" panel — opened, not submitted",
      "label": "Bulk upload"
    },
    {
      "src": "/docs/screens/users/row-delete-confirm.webp",
      "kind": "row-delete-confirm",
      "note": "Delete confirmation — CANCELLED, nothing deleted",
      "label": "Delete confirmation"
    },
    {
      "src": "/docs/screens/users/row-edit.webp",
      "kind": "row-edit",
      "note": "Edit form — opened, not saved",
      "label": "Edit form"
    },
    {
      "src": "/docs/screens/users/row-menu.webp",
      "kind": "row-menu",
      "note": "Row actions: View / Edit / Delete",
      "label": "Row actions"
    }
  ]
};

export default SCREENS;
